/* eslint-disable max-len */

import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const TemplateGalleryLivestreamingIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.0251 18.3084L18.9193 16.035C18.6648 15.8992 18.5121 15.6278 18.5121 15.3393L18.4951 11.1826C18.4951 10.8942 18.6478 10.6227 18.9023 10.487L23.0082 8.11168C23.5511 7.80629 24.2297 8.19651 24.2297 8.8073L24.2467 17.6128C24.2467 18.2236 23.585 18.6138 23.0251 18.3084Z"
      fill="currentColor"
    />
    <path
      d="M8.1626 14.5077V11.3694C8.1626 11.1221 8.42888 10.97 8.6381 11.1031C9.53204 11.6357 10.8825 12.1492 11.7384 12.6818C11.9476 12.8149 11.9476 13.1002 11.7384 13.2333C10.8825 13.7659 9.53204 14.2794 8.6381 14.812C8.42888 14.9071 8.1626 14.7549 8.1626 14.5077Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0359 15.9501C16.6796 15.9501 16.6796 16.5269 16.6796 16.7984C16.6796 17.7315 16.0689 18.5289 15.3732 18.5289C15.3732 18.5289 4.75232 18.5459 4.1076 18.5459C3.07266 18.5459 2.7503 17.9181 2.7503 17.1207C2.7503 16.7984 2.75029 15.0339 2.73333 13.2524C2.73333 11.4709 2.73333 9.70645 2.71636 9.38409C2.71636 8.58667 3.03872 7.95892 4.07367 7.95892C4.70142 7.95892 15.3393 7.94195 15.3393 7.94195C16.0349 7.94195 16.6457 8.73937 16.6457 9.67251C16.6457 9.94398 16.6457 10.5208 17.002 10.5208C17.2904 10.5208 17.3244 10.1136 17.3583 9.67251C17.4262 8.46791 16.8493 7.14453 15.2205 7.14453C15.2205 7.14453 4.32816 7.1615 3.9549 7.1615C2.27524 7.1615 1.85107 8.5697 1.85107 9.38409C1.85107 9.55375 1.85108 11.3861 1.86805 13.2524C1.86805 15.1187 1.86804 16.9511 1.88501 17.1207C1.88501 17.9351 2.30917 19.3433 3.98884 19.3433C4.3621 19.3433 15.2545 19.3264 15.2545 19.3264C16.8832 19.3264 17.4601 18.003 17.3922 16.7984C17.3753 16.3403 17.3413 15.9501 17.0359 15.9501Z"
      fill="currentColor"
    />
  </svg>
);
